import type { OrganizationState } from '../../types';

export function functionDeleted(
  organization: OrganizationState | undefined,
  functionUuid: string | undefined,
): boolean {
  return organization === undefined || functionUuid === undefined || !(functionUuid in organization.functionsById)
    ? true
    : organization.functionsById[functionUuid].deleted;
}
